export default {
  zh: {
    phoneNumPlaceholder: '手机号码',
    loginByPassword: '用密码登录',
    setPasswordPlaceholder: '密码',
    verificationPlaceholder: '验证码',
    getVerificationCode: '获取验证码',
    networkError: '网络错误，请稍后再试',
    sendAgain: '后重新发送',
    verificationCodeOrPwd: '密码不能为空',
    loginText: '登录',
    passwordPlaceholder: '密码',
    forgotPassword: '忘记密码？',
    signUp: '注册'
  },
  en: {
    phoneNumPlaceholder: 'Phone',
    loginByPassword: 'Password',
    setPasswordPlaceholder: 'Password',
    verificationPlaceholder: 'Your code',
    getVerificationCode: 'Send SMS',
    networkError: 'Network error, please try again later',
    sendAgain: ' ',
    verificationCodeOrPwd: 'The password is required',
    loginText: 'Sign In',
    passwordPlaceholder: 'Password',
    forgotPassword: 'Forget Password?',
    signUp: 'Register'
  }
}



// WEBPACK FOOTER //
// ./src/components/loginform/phoneLogin/lang.js